import { render, staticRenderFns } from "./DResizeImage.vue?vue&type=template&id=23ba7636&scoped=true&"
import script from "./DResizeImage.vue?vue&type=script&lang=js&"
export * from "./DResizeImage.vue?vue&type=script&lang=js&"
import style0 from "./DResizeImage.vue?vue&type=style&index=0&id=23ba7636&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ba7636",
  null
  
)

export default component.exports